import React from "react";
import { IInputProps, Input } from "./Input";

export interface IHiddenInputProps extends IInputProps {}

export const HiddenInput = React.forwardRef((props: IHiddenInputProps, ref: React.ForwardedRef<HTMLInputElement>) => (
    <Input {...props} type="hidden" />
));
